import { useColorScheme } from '@mantine/hooks';
import { useColorSchemeStore } from './color-scheme-store';

export { useColorSchemeStore } from './color-scheme-store';
export type { ColorSchemeType } from './color-scheme-store';

export const useAppColorScheme = () => {
  const colorScheme = useColorSchemeStore(({ colorScheme }) => colorScheme);
  const systemColorScheme = useColorScheme();
  return colorScheme === 'system' ? systemColorScheme : colorScheme;
};